export default [
  {
    title: 'DEBTIA_ADMIN_SETTINGS',
    icon: 'GridIcon',
    route: 'adminsettings',
    action: 'settings',
    resource: 'settings',
  },
]
